<!-- dummy invisible input for catch focus event from the <label> element -->
<input type="text" [disabled]="isDisabled" tabindex="-1" [id]="id" class="absolute h-0 w-0 opacity-0" />

<div
  class="relative cursor-pointer pr-10"
  [ngClass]="{
    '!outline-2 !outline-offset-2': isFocused && !isDisabled,
    '!shadow-[inset_0_0_0_1px_var(--input-active-border-color)]': isFocused && !isDisabled,
    '!outline-white': isFocused && !isDisabled && inverted,
    '!outline-focus': isFocused && !isDisabled && !inverted,
    '!shadow-[inset_0_0_0_1px_var(--input-disabled-border-color)]': isDisabled,
    '!py-2 !pl-2 !text-sm': density === 0,
    'bg-[--input-disabled-bg-color]': isDisabled,
  }"
  [class]="customDropdownClass"
  cslInput
  [inverted]="inverted"
  [attr.disabled]="isDisabled"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  @let selectedValues = selected();
  <!-- Custom template  -->
  @if (displayTemplate) {
    @if (selectedValues && selectedValues?.length) {
      <ng-template
        [ngTemplateOutlet]="displayTemplate"
        [ngTemplateOutletContext]="{ $implicit: selectedValues.slice().reverse() }"
      />
    } @else {
      <span
        ngClass="{
        'text-[--input-disabled-text-color]': isDisabled
      }"
      >
        {{ placeholder }}
      </span>
    }
  } @else {
    @let displayValue = getDisplayValue();
    @if (displayValue) {
      <div
        class="sel-input overflow-hidden text-ellipsis text-nowrap"
        [ngClass]="{ 'text-[--input-disabled-text-color]': isDisabled }"
      >
        {{ displayValue }}
      </div>
    } @else {
      <span
        [ngClass]="{
          'text-[--input-disabled-text-color]': isDisabled,
        }"
      >
        {{ placeholder }}
      </span>
    }
  }
  @if (isLoading) {
    <csl-icon [name]="'loading-icon'" class="absolute right-3 top-3 block h-6 w-6 animate-spin" />
  } @else {
    <csl-icon
      [name]="'dropdown-arrow'"
      [ngClass]="{
        'rotate-180': isOpen,
        'bg-[--input-disabled-text-color]': isDisabled,
        '!right-1 !top-1.5': density === 0,
      }"
      class="absolute right-3 top-3 block h-6 w-6"
    />
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPanelClass]="customCdkClass"
  [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.getBoundingClientRect().width"
  (overlayOutsideClick)="close(false)"
  (attach)="searchInput?.focus()"
  (detach)="onDropdownClose()"
  [cdkConnectedOverlayScrollStrategy]="closeScrollStrategy"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
    },
  ]"
>
  <div
    data-testid="select-container"
    class="sel-select g-dropdown-box-shadow mt-1 flex max-h-80 w-full max-w-full flex-col items-stretch overflow-hidden rounded-xl bg-white"
    #dropdownPanel
    [attr.id]="id + '-panel'"
    role="listbox"
    tabindex="-1"
    [attr.aria-multiselectable]="multiple"
  >
    @if (withSearch) {
      <div class="search-input relative mx-4 my-2">
        <input
          type="text"
          tabindex="-1"
          #search
          cslInput
          (init)="searchInput = search"
          ngModel
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="searchText.next($event)"
          (keydown)="this._handleKeydown($event)"
          class="!px-9 !py-2 !text-sm"
          [placeholder]="searchPlaceholder"
          data-testid="search-input"
        />
        <csl-icon [name]="'search-icon'" class="absolute left-2 top-1.5 block h-6 w-6 bg-blue-900" />
        @if (searchInput?.value) {
          <csl-icon
            [name]="'x-24'"
            class="absolute right-2 top-1.5 block h-6 w-6 cursor-pointer bg-blue-900"
            (click)="clearSearch(); searchInput?.focus()"
          />
        }
      </div>
    }
    <div class="g-dropdown-scrollbar sel-options grow">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
